import { initializeApp, getApps, getApp } from "firebase/app";
import { 
  getAuth, 
  setPersistence,
  indexedDBLocalPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
  inMemoryPersistence,
  GoogleAuthProvider,
  onAuthStateChanged
} from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getStorage } from "firebase/storage";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

console.log("🔥 FIREBASE CONFIG:", {
  apiKey: firebaseConfig.apiKey ? '✅ Presente' : '❌ FALTANDO',
  authDomain: firebaseConfig.authDomain ? '✅ Presente' : '❌ FALTANDO',
  projectId: firebaseConfig.projectId ? '✅ Presente' : '❌ FALTANDO',
  storageBucket: firebaseConfig.storageBucket ? '✅ Presente' : '❌ FALTANDO',
  messagingSenderId: firebaseConfig.messagingSenderId ? '✅ Presente' : '❌ FALTANDO',
  appId: firebaseConfig.appId ? '✅ Presente' : '❌ FALTANDO'
});

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const auth = getAuth(app);

// 🛡️ CONFIGURAR PERSISTÊNCIA SEM BLOQUEAR NADA
// iOS Safari pode bloquear IndexedDB completamente
let persistenceConfigured = false;

const configurePersistence = async () => {
  if (persistenceConfigured) return;
  
  const persistenceOptions = [
    { type: indexedDBLocalPersistence, name: 'IndexedDB' },
    { type: browserLocalPersistence, name: 'LocalStorage' },
    { type: browserSessionPersistence, name: 'SessionStorage' },
    { type: inMemoryPersistence, name: 'Memória (sem salvar)' }
  ];

  for (const option of persistenceOptions) {
    try {
      await setPersistence(auth, option.type);
      console.log(`✅ Persistência: ${option.name}`);
      persistenceConfigured = true;
      return;
    } catch (err) {
      console.warn(`⚠️ ${option.name} falhou:`, err.message);
      continue;
    }
  }
  
  // Se TUDO falhar, usa inMemory como fallback absoluto
  console.warn("⚠️ Usando modo SEM PERSISTÊNCIA (login não será salvo)");
  persistenceConfigured = true;
};

// Configurar imediatamente
configurePersistence().catch(err => {
  console.error("❌ Erro ao configurar persistência:", err);
  // NUNCA BLOQUEIA! App funciona mesmo sem persistência
});

export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });
googleProvider.addScope("profile");
googleProvider.addScope("email");

// Offline persistence: setDoc escreve no IndexedDB local imediatamente (sem round-trip Iowa).
// onSnapshot dispara com dados locais primeiro, depois sincroniza com o servidor.
// Resolve o matchmaking lento no 4G.
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});
export const storage = getStorage(app);

export function waitForAuthUser(timeoutMs = 5000) {
  return new Promise((resolve) => {
    if (auth.currentUser) {
      resolve(auth.currentUser);
      return;
    }
    let settled = false;
    const unsub = onAuthStateChanged(auth, (u) => {
      if (settled) return;
      settled = true;
      unsub();
      resolve(u || null);
    });
    setTimeout(() => {
      if (settled) return;
      settled = true;
      try { unsub(); } catch {}
      resolve(auth.currentUser || null);
    }, timeoutMs);
  });
}
export const functions = getFunctions(app, 'us-central1');
export const submitReps = httpsCallable(functions, "submitReps");

let messaging;
isSupported().then((supported) => {
  if (supported) {
    messaging = getMessaging(app);
  }
}).catch(() => {});

export { messaging };
